<template>
  <CardBase :contentPadding="'px-6 py-4'">
    <template #content>
      <div class="flex items-center justify-between border-b border-gray-300 pb-4 flex-wrap">
        <h1 class="text-xl font-semibold poppins w-full sm:w-1/2 md:w-auto">
          {{ row.name }}
          <!-- Buat list transaction gabungan dari semua account dia -->
          <!-- <router-link
            :to="{ name: 'MemberProfile', params: { memberId: row.id } }"
            class="text-sm ml-1 text-gray-600 text-opacity-50 hover:text-blue-600 hover:text-opacity-100"
            v-tooltip="'Member Profile'"
          >
            <font-awesome-icon :icon="['fas', 'user']" />
          </router-link> -->

          <router-link
            :to="{ name: 'MemberEdit', params: { id: row.id } }"
            class="text-sm ml-1 text-gray-600 text-opacity-50 hover:text-blue-600 hover:text-opacity-100"
            v-tooltip="'Edit Profile'"
          >
            <font-awesome-icon :icon="['fas', 'edit']" />
          </router-link>
        </h1>
        <div class="flex text-sm flex-wrap mt-4 sm:flex-no-wrap sm:w-1/2 sm:mt-0 lg:w-auto">
          <div class="flex items-center mr-4 flex-wrap w-full sm:w-auto">
            <span class="text-gray-600 inline-block mr-2 poppins w-full lg:w-auto">Last Deposit:</span>
            {{ (row.last_deposit) ? dateformat(row.last_deposit.date) : '-' }}
          </div>
          <!-- Created At -->
          <!-- <div class="flex items-center flex-wrap w-full sm:w-auto">
            <span class="text-gray-600 inline-block mr-2 poppins w-full lg:w-auto">Created At:</span>
            {{ dateformat(row.created_at )}}
          </div> -->
        </div>
      </div>
      <div class="flex flex-wrap border-b border-gray-300 py-4">
        <div class="w-full">
          <div class="flex items-center mb-1 text-gray-600 poppins">
            <font-awesome-icon :icon="['fas', 'user']" />
            <h4 class="ml-2 font-medium poppins">
              Account ID
              <router-link
                :to="{ name: 'AccountCreate', params: { memberId: row.id} }"
                class="text-sm ml-1 text-gray-600 text-opacity-50 hover:text-blue-600 hover:text-opacity-100"
                v-tooltip="'New Account ID'"
              >
                <font-awesome-icon :icon="['fas', 'plus-circle']" />
              </router-link>
            </h4>
          </div>
        </div>
        <div
          class="w-full mt-2 sm:w-1/2 md:w-1/3"
          v-for="account in row.accounts"
          :key="account.id"
        >
          <span
            class="block font-medium poppins"
          >{{ account.asset.name ? account.asset.name : 'n/a' }}</span>
          <router-link
            :to="{ name: 'AccountEdit', params: { memberId: row.id, id: account.id } }"
            class="link"
            v-tooltip="'Edit Account ' + account.panel_name"
          >
            {{ account.panel_name }}
            <span v-if="account.username && account.username != account.panel_name">/ {{ account.username }}</span>
          </router-link>
          <span class="block text-sm text-gray-600"><font-awesome-icon :icon="['fas', 'wallet']" /> {{ Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(account.balance) }}</span>
        </div>
      </div>
      <div class="flex flex-wrap pt-4">
        <div class="w-full">
          <div class="flex items-center mb-1 text-gray-600 poppins">
            <font-awesome-icon :icon="['fas', 'piggy-bank']" />
            <h4 class="ml-2 font-medium poppins">
              Bank Accounts
              <router-link
                :to="{ name: 'MemberBankCreate', params: { memberId: row.id} }"
                class="text-sm ml-1 text-gray-600 text-opacity-50 hover:text-blue-600 hover:text-opacity-100"
                v-tooltip="'New Bank Account'"
              >
                <font-awesome-icon :icon="['fas', 'plus-circle']" />
              </router-link>
            </h4>
          </div>
        </div>
        <div
          class="w-full mt-2 sm:w-1/2 md:w-1/3"
          v-for="member_bank in row.member_banks"
          :key="member_bank.id"
        >
          <span class="block font-medium poppins">{{ member_bank.bank_type.name }}</span>
          <router-link
            :to="{ name: 'MemberBankEdit', params: { memberId: row.id, id: member_bank.id } }"
            class="link"
            v-tooltip="'Edit Bank Account ' + member_bank.account_holder + ' - ' + member_bank.account_number"
          >{{ member_bank.account_holder }} - {{ member_bank.account_number }}</router-link>
        </div>
      </div>
    </template>
  </CardBase>
</template>

<script>
export default {
  name: "MemberCard",
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  methods: {
    dateformat(date) {
      return this.moment(date).format("DD MMM YYYY | HH:mm");
    },
  },
};
</script>